(() => {
  'use strict';

  if (window.RwadyMetaCheckoutLoaded) return;
  window.RwadyMetaCheckoutLoaded = true;

  const PIXEL_ID = '1479806853446161';
  const ROOT = window.Shopify?.routes?.root || '/';
  const API_BASE = 'https://account.rwady.com.iq';
  let cartPromise;

  const cookieValue = (name) => {
    const prefix = `${name}=`;
    const entry = String(document.cookie || '').split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
    return entry ? decodeURIComponent(entry.slice(prefix.length)) : '';
  };

  const sendServerEvent = (event) => {
    if (!event?.event_id || !event?.event_name || !event?.custom_data) return Promise.resolve(false);
    return fetch(`${API_BASE}/meta/events`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        ...event,
        event_source_url: window.location.href,
        fbp: cookieValue('_fbp'),
        fbc: cookieValue('_fbc')
      })
    }).then((response) => response.ok).catch(() => false);
  };

  const ensurePixel = () => {
    if (typeof window.fbq === 'function') return window.fbq;
    const fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    fbq('init', PIXEL_ID);
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.append(script);
    return fbq;
  };

  const fetchCart = (refresh = false) => {
    if (!cartPromise || refresh) {
      cartPromise = fetch(`${ROOT}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      }).catch(() => null);
    }
    return cartPromise;
  };

  const hash = (value) => {
    let result = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      result ^= value.charCodeAt(index);
      result = Math.imul(result, 16777619);
    }
    return (result >>> 0).toString(36);
  };

  const cartEvent = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const contents = items.map((item) => ({
      id: String(item.variant_id || item.sku || item.product_id || ''),
      quantity: Math.max(1, Number(item.quantity) || 1),
      item_price: Math.max(0, Number(item.final_price ?? item.price) || 0) / 100
    })).filter((item) => item.id);
    const signature = hash(JSON.stringify({
      token: cart?.token || '',
      total: cart?.total_price || 0,
      items: contents
    }));
    return {
      signature,
      parameters: {
        content_type: 'product',
        content_ids: contents.map((item) => item.id),
        contents,
        num_items: contents.reduce((sum, item) => sum + item.quantity, 0),
        currency: cart?.currency || 'IQD',
        value: Math.max(0, Number(cart?.total_price) || 0) / 100
      }
    };
  };

  const sendOnce = (eventName, standard, cart) => {
    if (!cart?.items?.length) return false;
    const event = cartEvent(cart);
    const eventId = `rwady_${eventName.toLowerCase()}_${event.signature}`;
    const storageKey = `rwady-meta-${eventId}`;
    try {
      if (sessionStorage.getItem(storageKey) === 'sent') return false;
    } catch (_) {}
    const fbq = ensurePixel();
    fbq(standard ? 'track' : 'trackCustom', eventName, event.parameters, { eventID: eventId });
    try { sessionStorage.setItem(storageKey, 'sent'); } catch (_) {}
    return true;
  };

  const trackInformationView = () => fetchCart().then((cart) => sendOnce('CheckoutInformationView', false, cart));

  const addedContents = (payload) => {
    const items = Array.isArray(payload?.items) ? payload.items : [payload];
    return items.map((item) => ({
      id: String(item?.variant_id || item?.sku || item?.product_id || item?.id || ''),
      quantity: Math.max(1, Number(item?.quantity) || 1),
      item_price: Math.max(0, Number(item?.final_price ?? item?.price) || 0) / 100
    })).filter((item) => item.id && item.item_price >= 0).slice(0, 20);
  };

  const eventNonce = () => {
    try { return crypto.randomUUID(); } catch (_) { return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`; }
  };

  const trackAddToCart = (payload) => {
    const contents = addedContents(payload);
    if (!contents.length) return false;
    const eventId = `rwady_addtocart_${eventNonce()}`;
    const customData = {
      content_type: 'product',
      content_ids: contents.map((item) => item.id),
      contents,
      num_items: contents.reduce((sum, item) => sum + item.quantity, 0),
      currency: 'IQD',
      value: contents.reduce((sum, item) => sum + item.item_price * item.quantity, 0)
    };
    ensurePixel()('track', 'AddToCart', customData, { eventID: eventId });
    void sendServerEvent({ event_name: 'AddToCart', event_id: eventId, custom_data: customData });
    return true;
  };

  ensurePixel();
  fetchCart();

  document.addEventListener('maximize:cart:updated', () => fetchCart(true));
  document.addEventListener('rwady:cart-add-success', (event) => trackAddToCart(event.detail?.added));

  if (document.querySelector('[data-rwady-checkout-information]')) {
    trackInformationView();
  }

  window.RwadyMetaCheckout = { trackInformationView, trackAddToCart, sendServerEvent };
  const queued = Array.isArray(window.RwadyMetaServerQueue) ? window.RwadyMetaServerQueue.splice(0) : [];
  queued.forEach((event) => { void sendServerEvent(event); });
})();
